import "../data/css/Contact.scss"
import {
    AiFillGithub,
    AiOutlineLinkedin,
    HiOutlineMail,
} from "react-icons/all";
import {useGlobal} from "../contexts/GlobalContext";

export default function Contact() {
    const {isMobile} = useGlobal()
    const padding = isMobile ? "p-2" : "p-5"
    const size = "4rem"
    return (
        <div className={"aalp1 container-fluid"}>
            <h2 className={"title text-center pb-0"}>Contact</h2>
            <h5 className={"text-center pb-5 color-gray"}>I'm open to new projects or a job.</h5>
            <div className={"contact-icons"}>
                <div className={"d-flex justify-content-center"}>
                    <a href="mailto: hello@jakubkwiatkowski.pl" className={padding}> <HiOutlineMail size={size}/></a>
                    <a rel="noreferrer" className={padding} target={"_blank"}
                       href={"https://www.linkedin.com/in/jakub-kwiatkowski-004bb7194/"}><AiOutlineLinkedin
                        size={size}/></a>
                    {/*<a className={padding}  target={"_blank"} href={"https://m.me/KubcioPro"}><RiMessengerLine size={size}/></a>*/}
                    <a rel="noreferrer" className={padding} target={"_blank"}
                       href={"https://github.com/panjacob"}><AiFillGithub size={size}/></a>
                </div>
            </div>
        </div>
    );
}


